import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {SignupPage} from './signup.page';
import {GlobalModule} from "../../../global-module/global-module.module";

const routes: Routes = [
    {
        path: '',
        component: SignupPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GlobalModule,
        RouterModule.forChild(routes)
    ],
    declarations: [SignupPage]
})
export class SignupPageModule {
}
